import React, {useState} from 'react';
import {Controller, useForm} from "react-hook-form";
import {useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {forgotPassword} from "../../Services/auth";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../store/features/loadingSlice";

const ForgotPassword = () => {
    const {handleSubmit, control, formState, reset} = useForm();
    const [showPassword, setShowPassword] = useState(false);
    const [cookies, setCookie] = useCookies(["jwtToken"]);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleForgotPassword = async (data) => {
        dispatch(SET_IS_API_CALLED("Sending Data"));
        forgotPassword(data?.email)
            .then((res)=> {
                navigate("/login");
            })
            .finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED());
            });


    }

    return (<form onSubmit={handleSubmit(handleForgotPassword)}>
        <div className="h-screen flex justify-center items-center bg-light-blue-100">
            <div className="bg-white grid grid-cols-8 w-[970px] h-[574px] rounded-md shadow-md">
                <div className="flex col-span-4 justify-center items-center">
                    <img
                        src="assets/airselangor-logo.svg"
                        className=" w-[385px] h-[105]"
                        alt=""
                    />
                </div>
                <div className="w-full col-span-4 p-16 ">
                    <div className="mb-4 text-[25px] leading-normal text-center text-medium-blue font-bold">
                        <img src={"/assets/HYDROSMART Icon-02.png"} alt="Logo" className="w-full"/>
                    </div>
                    <div className="mb-4 mt-10 relative">
                        <label
                            htmlFor="email"
                            className="block text-sm font-normal text-medium-grey-100"
                        >
                            Email Address
                        </label>
                        <Controller
                            name={`email`}
                            control={control}
                            rules={{
                                required: "Email is required", pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            }}
                            render={({field}) => (<>
                                <input
                                    type="email"
                                    value={field.value}
                                    onChange={field.onChange}
                                    className="mt-1 block w-full px-3 placeholder:text-black placeholder:text-lg font-normal py-2 border-b outline-none rounded focus:ring focus:ring-indigo-300"
                                    placeholder="abc@example.com"
                                    required
                                />
                                <p className="mt-2 text-red-500 text-xs">
                                    {formState?.errors?.password?.message || " "}
                                    {formState?.errors?.password?.type === "pattern" ? "Wrong Pattern" : " "}
                                </p>
                            </>)}
                        />
                    </div>

                    <div className="mb-6">
                        <button
                            className="w-full bg-dark-blue-100 text-white text-lg font-bold h-[50px] hover:bg-blue-600"
                            type="submit"
                        >
                            Submit
                        </button>
                    </div>

                    <div
                        onClick={() => navigate("/login")}
                        className="cursor-pointer text-sm text-medium-grey-100 text-center"
                    >
                        <span>Back to login?</span>
                    </div>
                </div>
            </div>
        </div>
    </form>);
};

export default ForgotPassword;